import { api } from '../../helpers/Api';
var PaylandsStore = /** @class */ (function () {
    function PaylandsStore() {
    }
    PaylandsStore.prototype.getToken = function (UUID) {
        console.log('UUID: ', UUID);
        return api.post('/paymentCustomer', {
            customer_ext_id: UUID
        });
        // return api.post(`agencies/${agency_id}/customer`)
    };
    return PaylandsStore;
}());
export default PaylandsStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Paylands/PaylandsStore.ts
// module id = 753
// module chunks = 0